import { ChartColors } from '../../../../../shared/components/charts/ChartColors';
import React from 'react';

export const CustomLegend = ({ data, colors }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: 10 }}>
      {/* Iterate over data to display legend items */}
      {data.map((entry, index) => (
        <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
          <div style={{
            width: 10,
            height: 10,
            //if colors is not array and it is dictionary then use colors[entry.name] instead of colors[index % colors.length]
            backgroundColor: Array.isArray(colors) ? colors[index % colors.length] : colors[entry.name],




            marginRight: 8,
          }}></div>
          <span style={{ fontSize: data.length > 5 ? '10px' : '12px' }}>{entry.name}</span>
        </div>
      ))}
    </div>
  );
};